export default __webpack_public_path__ + "static/media/specialoffers.ae4ea7e2.png";